import { Outlet } from "react-router-dom";

const ProgramCategoriesLayout = () => {
  return <Outlet />;
};

export default ProgramCategoriesLayout;